import SelectedSubscriptionDetails from './SelectedSubscriptionDetails'
import SubscriptionsList from './SubscriptionsList'

export default ({ products, subscription, setSubscription, addToCart, cart, t, language }) => (
  <div className="columns m-t-lg">
    <div className="column is-4 is-paddingless">
      <SubscriptionsList
        products={products}
        subscription={subscription}
        setSubscription={setSubscription}
        language={language}
        t={t} />
    </div>
    <div className="column is-8 is-paddingless">
      <SelectedSubscriptionDetails
        subscription={subscription}
        addToCart={addToCart}
        loading={cart.loading}
        cartItems={cart.items}
        t={t} />
    </div>
  </div>
)



// WEBPACK FOOTER //
// ./components/SubscriptionsSelector/index.js